module.exports = __webpack_public_path__ + "img/portrait-013.00641396.jpg";